import React from 'react';
import PropTypes from 'prop-types';
import withFavorites from './WithFavorites';

export function RegionsListItemComponent({ handleClick, region }) {
  return (
    <div>
      <a
        tabIndex="0"
        onClick={() => { handleClick('regions', region); }}
      >
        {region.name}
      </a>
    </div>
  );
}

RegionsListItemComponent.propTypes = {
  region: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
  handleClick: PropTypes.func.isRequired,
};

export default withFavorites(RegionsListItemComponent);



// WEBPACK FOOTER //
// ./src/components/List/Areas/RegionsListItem.js